import React from 'react';
import { initReactAppByAttribute } from 'shared/util/ApplicationInit';
import RecentlyViewedProducts from './RecentlyViewedProducts';

const render = initReactAppByAttribute(() => <RecentlyViewedProducts />, 'data-recently-viewed-products');

render();

// optional, use this to enable hot reloading
if ((module as any).hot) {
	(module as any).hot.accept('./RecentlyViewedProducts', () => {
		render();
	});
}
